import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'fx-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.sass']
})
export class TabComponent implements OnInit {
  @Input() tabs: any[] = [];
  @Input() activeTab: any;
  @Output() selected = new EventEmitter();
  constructor() {}

  ngOnInit(): void {
    this.selected.emit(this.activeTab)
  }

  select(event): void {
    $('ul.p-tabmenu-nav li').each((i , ele) => {
      if ($(ele).hasClass('p-highlight')) {
        this.activeTab =  this.tabs[i];
        this.selected.emit(this.activeTab)
      }
    });
  }
}
